/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionBalance } from '../../models/subscription-balance';

export interface GetSubscriptionBalance$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getSubscriptionBalance(http: HttpClient, rootUrl: string, params: GetSubscriptionBalance$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionBalance>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionBalance.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionBalance>;
    })
  );
}

getSubscriptionBalance.PATH = '/custom/subscriptions/{uid}/balance';
